<template>
    <TabsTrigger
        class="group gap-3 rounded-lg p-2.5 hover:bg-iron-100 data-[state=active]:bg-iron-100 relative flex w-[190px] items-center"
        :value="value"
    >
        <div class="text-iron-500 group-data-[state=active]:text-[#e92f34]">
            <slot name="icon"> </slot>
        </div>

        <p
            class="text-sm font-medium text-iron-500 group-data-[state=active]:text-iron-700"
        >
            <slot name="text" />
        </p>

        <TooltipProvider v-if="hasWarning">
            <Tooltip>
                <TooltipTrigger as-child>
                    <span
                        class="right-2 pointer-events-auto absolute top-1/2 -translate-y-1/2 cursor-help"
                        :aria-label="props.warningMessage"
                        role="img"
                    >
                        <span
                            class="h-2 w-2 block rounded-full"
                            :class="getWarningDotClasses(hasWarning)"
                        ></span>
                    </span>
                </TooltipTrigger>
                <TooltipContent :side-offset="10">
                    <p class="max-w-[180px]">{{ props.warningMessage }}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    </TabsTrigger>
</template>

<script setup lang="ts">
import { TabsTrigger, type TabsContentProps } from "radix-vue";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { getWarningDotClasses } from "../utils/getWarningDotClasses";

interface Props extends TabsContentProps {
    hasWarning?: boolean;
    warningMessage?: string;
}

const props = defineProps<Props>();
</script>
